import React from 'react'
import cx from 'classnames'
import { connectHits } from 'react-instantsearch-dom'

import { MediaCard } from '~components/shared'

const Hits = ({ hits, displayStyle }) => {
  return (
    <div className={cx('flex flex-wrap md:flex-row mb-16', displayStyle === 'card' && '-mx-4')}>
      {hits.map(hit => (
        <div
          key={hit.objectID}
          className={cx('flex w-full', displayStyle === 'card' ? 'md:w-1/2 lg:w-1/3 px-4 pb-8' : 'pb-8')}
        >
          <MediaCard
            image={hit?.image}
            title={hit.title}
            question={hit.question || null}
            type={hit.type === 'Resource' ? 'Service' : hit.type}
            slug={hit.slug}
            tags={hit?.secondaryTopics ? hit.primaryTopics.concat(hit.secondaryTopics) : hit.primaryTopics || null}
            displayStyle={displayStyle}
            caption={hit.caption}
            url={hit.url}
            onlyShowCaptionWhenWide
          />
        </div>
      ))}
    </div>
  )
}

export default connectHits(Hits)
